import FreeOffer from './FreeOffer';

export default FreeOffer;
